<template>
    <div class="menu_container">
        <div>
            <label>Filename: </label>
            <input ref="newName" type="text" @input="emitName" :value="filename">
        </div>
        <div class="options">
            <CheckboxItem v-for="(option, index) in optionsArr" :key="index" :text="option.text" :value="option.value" :type="option.type" ></CheckboxItem>
        </div>
    </div>
    
</template>
<script>
import CheckboxItem from './checkboxItem';
export default {
    name: "optionsMenu",
    components:{
        CheckboxItem
    },
    props:[
        "filename"
    ],
    data(){
        return{
            optionsArr:[
                {
                    text: "zft",
                },
                {
                    text: "dpi",
                    type: "number",
                    value: 72
                },
                {
                    text: "level",
                    type: "number",
                    value: 2,
                    min: 0,
                    max: 4
                },
                {
                    text: "leveli",
                    type: "number",
                    value: 1,
                    min: 0,
                    max: 3
                },
                {
                    text: "sd_thresh",
                    type: "number",
                    value: 8,
                    max: 12,
                    min: 6,
                },
                {
                    text: "max_thresh",
                    type: "number",
                    value: 0.9,
                    max: 0.98,
                    min: 0.8,
                    step: 0.1
                },
                {
                    text: "min_thresh",
                    type: "number",
                    value: 0.55,
                    max: 0.70,
                    min: 0.45,
                    step: 0.1
                },
                {
                    text: "feature_density",
                    type: "number",
                    value: 70,
                    max: 200,
                    min: 70
                },
            ]
        }
    },
    methods:{
        emitName(e){
            this.$root.$emit("changeName", e.target.value)
        }
    }

}
</script>
<style scoped>
.options{
  display: grid;
  grid-template-columns: auto auto ;
  column-gap: 10px;
  row-gap: 10px;
  margin-left: 10px;
  margin-right: 10px;
}
.menu_container{
    color: black;
}
</style>